<template>
  <div class="foot ljb-flex-row">
    <div
      v-for="(item,index) in footList"
      :key="index"
      class="item"
      @click="footFn(index,item)">
      <img
        :src="index == currentIndex?item.srcColor:item.src"
        class="imgs">
      <p :class="index == currentIndex ?'base_color':'text'">{{ item.name }}</p>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'LjbFooter',
  props: {
    currentIndex: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      footList: [{
        src: 'https://cdn.51ljb.cn/ljb_icons_footer_home_grey.png',
        srcColor: 'https://cdn.51ljb.cn/ljb_icons_footer_home_active.png',
        name: '首页',
        path: '/Home'
      }, {
        src: 'https://cdn.51ljb.cn/ljb_icons_footer_service_grey.png',
        srcColor: 'https://cdn.51ljb.cn/ljb_icons_footer_service_active.png',
        name: '服务商城',
        path: 'ServiceMall'
      },
      {
        src: 'https://cdn.51ljb.cn/ljb_icons_footer_lawyer_grey.png',
        srcColor: 'https://cdn.51ljb.cn/ljb_icons_footer_lawyer_active.png',
        name: '选律师',
        path: 'Lawyer'
      }, {
        src: 'https://cdn.51ljb.cn/ljb_icons_footer_info_grey.png',
        srcColor: 'https://cdn.51ljb.cn/ljb_icons_footer_info_active.png',
        name: '资讯',
        path: 'Information'
      }, {
        src: 'https://cdn.51ljb.cn/ljb_icons_footer_user_grey.png',
        srcColor: 'https://cdn.51ljb.cn/ljb_icons_footer_user_active.png',
        name: '我的',
        path: 'User'
      }]
    }
  },
  computed: {
    ...mapGetters('User', [
      'getUserInfo',
      'getShowLogin'
    ])
  },
  methods: {
    footFn (index, item) {
      this.$router.push(item.path)
      // let loginInfo = {
      //   login: false,
      //   path: ''
      // }
      // if (this.getUserInfo || index === 0) {
      //   console.log(this.getUserInfo)
      //
      //   return
      // }
      // this.$store.commit('User/setShowLogin', true)
      // loginInfo.path = item.path
      // this.$emit('loginFn', loginInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
  .foot {
    background: #fff;
    justify-content: space-between;
    position: fixed;
    left: 0;
    z-index: 20;
    bottom: 0;
    height: 49px;
    box-sizing: border-box;
    width: 100%;
    .item{
      flex: 1;
      @extend .ljb-flex-column;
      @extend .ljb-double-center;
      font-size: 10px;
      .imgs{
        width: 20px;
        height: 20px;
      }

      .text {
        color: #999;
      }
      .base_color {
        color: $base-color;
      }
    }
    &:after{
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 1px;
      background-color: #eee;
      -ms-transform-origin: 0 0;
      transform-origin: 0 0;
      transform: scaleY(0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LjbFooter.vue